import { BadgeCheck } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { SectionHeading } from "@/components/SectionHeading";
import { Stars } from "@/components/Stars";

export default function Reviews({ reviews }) {
  if (!reviews?.length) return null;
  return (
    <section data-testid="reviews-section" className="bg-[#F4F3EF]">
      <div className="mx-auto max-w-7xl px-4 py-16 sm:px-6 sm:py-24 lg:px-8">
        <SectionHeading
          align="center"
          index="05"
          overline="Social Proof"
          title="Loved by Everyday Shoppers"
          sub="Over 15,000+ happy customers across India simplify their homes and routines with Everyday Essentials."
        />
        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {reviews.slice(0, 3).map((r, i) => (
            <Reveal key={r.author} delay={i * 0.09}>
              <figure className="flex h-full flex-col rounded-2xl border border-neutral-200/60 bg-white p-7" data-testid={`review-card-${i}`}>
                <span className="font-serif text-5xl italic leading-none text-neutral-200">&ldquo;</span>
                <Stars rating={r.rating} className="mt-2" />
                <blockquote className="mt-4 flex-1 text-sm leading-relaxed text-neutral-600">{r.quote}</blockquote>
                <figcaption className="mt-6 border-t border-neutral-100 pt-4">
                  <div className="flex items-center gap-1.5">
                    <span className="text-sm font-semibold text-neutral-900">{r.author}</span>
                    {r.verified && <BadgeCheck size={15} className="text-emerald-600" />}
                  </div>
                  <p className="mt-0.5 text-xs text-neutral-400">
                    {r.location} · Purchased: {r.purchased}
                  </p>
                </figcaption>
              </figure>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
